export const payrollAdditional = [
  {
    key:"1",
    Name: "Leave Balance Amount",
    Category: "Monthly Remuneration",
    Amount: "$5",
  },
  {
    key:"2",
    Name: "Arrears of Salary",
    Category: "Additional Remuneration",
    Amount: "$8",
  },
  {
    key:"3",
    Name: "Gratuity",
    Category: "Monthly Remuneration",
    Amount: "$20",
  },
];
